import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

// Register Service Worker and subscribe to push notifications (optional)
(async () => {
  try {
    // Check if VAPID key is properly configured
    const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
    if (!vapidKey || vapidKey === 'placeholder_vapid_key' || vapidKey.length < 20) {
      console.log('Push notifications disabled: VAPID key not configured');
      return;
    }

    const { registerServiceWorker, ensureNotificationPermission, subscribePush, sendSubscriptionToServer } = await import('./utils/push');
    
    const reg = await registerServiceWorker();
    if (!reg) return;
    
    const granted = await ensureNotificationPermission();
    if (!granted) return;
    
    const sub = await subscribePush(reg);
    if (!sub) return;
    
    const token = localStorage.getItem('token');
    const userEmail = localStorage.getItem('email');
    await sendSubscriptionToServer(sub.toJSON(), token, userEmail);
    
    console.log('Push notifications initialized successfully');
  } catch (error) {
    console.log('Push notifications not available or failed to initialize:', error.message);
  }
})();
